import { createContext, useContext, useState } from "react";

const ChartContext = createContext(null);

export const ChartProvider = ({ children }) => {
  const [chartResponse, setChartResponse] = useState(null);
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ChartContext.Provider
      value={{
        chartResponse,
        setChartResponse,
        error,
        setError,
        isSubmitting,
        setIsSubmitting,
      }}
    >
      {children}
    </ChartContext.Provider>
  );
};

export const useChart = () => {
  const context = useContext(ChartContext);
  if (!context) {
    throw new Error("useChart must be used within a ChartProvider");
  }
  return context;
};



